import { Box } from "@mantine/core"
import type React from "react"
import { memo } from "react"
import { twJoin } from "tailwind-merge"

type RadialProgressProps = {
  percentage: number
}

const RadialProgress: React.FC<RadialProgressProps> = ({ percentage }) => {
  return (
    <Box
      sx={{
        background: `radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(${percentage === 100 ? "#008556" : "#0C0A09"
          } ${percentage}%, #F3EFEA 0%)`,
        animation: `fillProgress 5s ease-in-out forwards`,
      }}
      className="w-[80px] h-[80px] rounded-full flex items-center justify-center"
    >
      <div className="bg-white w-[73px] h-[73px] rounded-[inherit] flex items-center justify-center">
        <span id="counter" className={twJoin("text-pn-large-title text-pn_gray-950", "!text-[26px]")}>
          {percentage}%
        </span>
      </div>
    </Box>
  )
}
export default memo(RadialProgress)
